@use '../styles/variables' as *;

// Block: nav-menu
.nav-menu {
    position: fixed;
    inset: 0;
    z-index: 100;
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease;

    // Modifier: open state
    &--open {
        opacity: 1;
        pointer-events: auto;

        .nav-menu__drawer {
            transform: translateX(0);
        }
    }

    // Element: drawer
    &__drawer {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        width: 80%;
        max-width: 320px;
        background: $color-surface-glass;
        backdrop-filter: blur($blur-xl);
        -webkit-backdrop-filter: blur($blur-xl);
        border-right: 1px solid $color-surface-glass-border;
        transform: translateX(-100%);
        transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);
        display: flex;
        flex-direction: column;
        padding: $space-04;
    }

    // Element: header
    &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: $space-06;
    }

    // Element: title
    &__title {
        font-family: $font-display;
        font-size: 1.5rem;
        font-weight: 700;
        color: $color-text-primary;
        margin: 0;
    }

    // Element: close button
    &__close-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        // WCAG 2.1 AA minimum target (F27).
        width: $touch-target-min;
        height: $touch-target-min;
        border-radius: $radius-full;
        background-color: rgba(255, 255, 255, 0.1);
        color: $color-text-primary;
        border: none;
        cursor: pointer;
        transition: background-color 0.2s ease;

        &:hover {
            background-color: rgba(255, 255, 255, 0.15);
        }
    }

    // Element: list
    &__list {
        display: flex;
        flex-direction: column;
        gap: $space-02;
    }

    // Element: item
    &__item {
        display: flex;
        align-items: center;
        gap: $space-03;
        padding: $space-03;
        border-radius: $radius-lg;
        background: transparent;
        border: none;
        text-decoration: none;
        color: $color-text-secondary;
        transition: all 0.2s ease;

        &:hover {
            background-color: rgba(255, 255, 255, 0.05);
            color: $color-text-primary;
        }

        // Modifier: active state
        &--active {
            background-color: rgba($color-neon-lime, 0.1);
            color: $color-neon-lime;

            &:hover {
                background-color: rgba($color-neon-lime, 0.15);
                color: $color-neon-lime;
            }
        }
    }

    // Element: item icon
    &__item-icon {
        font-size: 1.5rem;
    }

    // Element: item label
    &__item-label {
        font-family: $font-body;
        font-size: 1.125rem;
        font-weight: 500;
    }

    // Element: footer
    &__footer {
        margin-top: auto;
        padding-top: $space-04;
        border-top: 1px solid $color-border-subtle;
    }

    // Element: footer link
    &__footer-link {
        display: flex;
        align-items: center;
        gap: $space-03;
        padding: $space-03;
        color: $color-text-secondary;
        text-decoration: none;
        font-family: $font-body;
        font-size: 1rem;
        border-radius: $radius-lg;
        transition: all 0.2s ease;

        &:hover {
            background-color: rgba(255, 255, 255, 0.05);
            color: $color-text-primary;
        }
    }
}
